import { useMutation, useQuery } from "react-query"
import customAxios from "../utils/customAxios"
import { toast } from "react-toastify"
import { AxiosError } from "axios"

const axios = customAxios()

const fetchUpdateGet = () => {
  return axios.get(`/cmat/profile/update`)
}

const fetchUpdateApi = () => {
  return axios.post(`/cmat/profile/update`)
}

export const useUpdateGetApi = (prop?: any) => {
  return useQuery(["fetchUpdateGet", prop], fetchUpdateGet, {
    staleTime: 10000,
    select,
    onError,
    refetchOnWindowFocus: false,
  })
}

export const useUpdateApi = (prop?: any) => {
  return useMutation(fetchUpdateApi, {
    onSuccess: () => {
      toast.success("학문프로파일 업데이트 성공")
    },
    onError: (error: AxiosError) => {
      console.log(error)
    },
  })
}

// api 응답 데이터 가공하는 부분
const select = (response: any) => {
  return response.data
}

const onError = (err: any) => {
  return err
}
